import { Route, Routes } from 'react-router-dom'

import type { AgencyModel, ProviderAccountModel } from '@models/types'

import ProviderAccount from './screens/ProviderAccount'
import Relations from './screens/Relations'

interface ProviderAgencyEditRoutesProps {
  agency: AgencyModel,
  providerAccount: ProviderAccountModel,
}

const ProviderAgencyEditRoutes = (props: ProviderAgencyEditRoutesProps) => {
  const { agency, providerAccount } = props

  return (
    <Routes>
      <Route index element={<ProviderAccount agency={agency} providerAccount={providerAccount} />} />

      <Route path="/relations" element={<Relations agency={agency} />} />
    </Routes>
  )
}

export default ProviderAgencyEditRoutes
